import React, {useEffect} from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import AboutImg from "../assets/hero/abouus.jpg";
import Footer from "../components/Footer";
import AboutUs from "../components/AboutUs";
import RestTeam from "../components/RestTeam";

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Sobre Nos | Cubic";
  }, []);
  return (
    <>
      <Navbar />
      <Hero
        cName="hero-mid"
        heroImg={AboutImg}
        title="Sobre Nós"
        titleClass="page-title"
        btnClass="hide"
      />
      <AboutUs />
      <RestTeam />
      <Footer />
    </>
  );
}

export default About;
